module.exports = __webpack_public_path__ + "static/dietcola-39faca6e3efc4a5a25297e549307d045.jpg";